<template>
  <div>
    <slot name="label">
      <span class="text-muted mb-2">Tipo de solicitud<span class="text-danger ml-1">*</span></span>
    </slot>
    <b-row>
      <b-col cols="12" :md="multiColumn ? 3 : 12" class="mt-1">
        <b-form-select
          v-model="selectedDepartment"
          :options="departmentOptions"
          class="mb-2 mb-sm-0 mr-2 mr-sm-0"
          style="width: 100%"
          autofocus
          :state="selectedDepartment ? true : false"
          @change="fetchRequestTypes"
        >
          <template #first>
            <b-form-select-option :value="null">-- Departamento --</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" :md="multiColumn ? 4 : 12" class="mt-1">
        <b-form-select
          v-model="selectedRequestType"
          :options="requestTypeOptions"
          class="mb-2 mb-sm-0 mr-2 mr-sm-0"
          style="width: 100%"
          :disabled="!selectedDepartment"
          :state="selectedRequestType ? true : false"
          @change="fetchRequirements"
        >
          <template #first>
            <b-form-select-option :value="null">-- Tipo de solicitud --</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" :md="multiColumn ? 5 : 12" class="mt-1">
        <b-form-select
          v-model="selectedRequirement"
          :options="requirementOptions"
          class="mb-2 mb-sm-0 mr-2 mr-sm-0"
          :disabled="!selectedRequestType"
          style="width: 100%"
          :state="selectedRequirement ? true : false"
          @change="setInternalTicketLevel(selectedRequirement)"
        >
          <template #first>
            <b-form-select-option :value="null">-- Requerimiento --</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'LevelSelectable',
  props: {
    ticketLevel: {
      type: Object,
      required: false,
      default: () => ({
        department: null,
        request_type: null,
        requirement: null,
        id: null
      })
    },
    fetchOnMount: {
      type: Boolean,
      required: false,
      default: false
    },
    multiColumn: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      // TODO: ADD PROCESSING
      //  TODO: ADD DISPLAY ALERTS
      selectedDepartment: null,
      departmentOptions: [],
      selectedRequestType: null,
      requestTypeOptions: [],
      selectedRequirement: null,
      requirementOptions: []
    }
  },
  mounted () {
    if (this.ticketLevel.id) {
      this.setInitialData()
    } else {
      this.fetchDepartments()
    }
  },
  methods: {
    setDisplayData () {
      const department = this.ticketLevel.department
      const requestType = this.ticketLevel.request_type
      const requirement = this.ticketLevel.requirement

      this.selectedDepartment = department
      this.selectedRequestType = requestType
      this.selectedRequirement = requirement

      this.requestTypeOptions = requestType
        ? [{ text: requestType, value: requestType }]
        : []

      this.requirementOptions = requirement
        ? [{ text: requirement, value: requirement }]
        : []
    },
    setInitialData () {
      this.selectedDepartment = this.ticketLevel.department
      this.selectedRequestType = this.ticketLevel.request_type
      this.selectedRequirement = this.ticketLevel.id

      this.$http.get(`/api/production/internal_ticket_levels/${this.ticketLevel.id}/level_options`)
        .then(response => {
          const { departments, request_types, requirements } = response.data
          this.departmentOptions = this.sortOptions(departments.map(department => ({ text: department, value: department })))
          this.requestTypeOptions = this.sortOptions(request_types.map(request_type => ({ text: request_type, value: request_type })))
          this.requirementOptions = this.sortOptions(requirements.map(requirement => ({ text: requirement.requirement, value: requirement.id })))
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchDepartments () {
      this.$http.get('/api/production/internal_ticket_levels/departments')
        .then(response => {
          this.$emit('setInternalTicketLevel', null)
          this.selectedDepartment = null
          this.selectedRequestType = null
          this.selectedRequirement = null
          this.departmentOptions = this.sortOptions(response.data.map(department => ({ text: department, value: department })))
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchRequestTypes () {
      if (!this.selectedDepartment) {
        this.$emit('setInternalTicketLevel', null)
        this.selectedRequestType = null
        this.selectedRequirement = null
        return
      }
      this.$http.get('/api/production/internal_ticket_levels/request_types', {
        params: {
          department: this.selectedDepartment
        }
      })
        .then(response => {
          this.$emit('setInternalTicketLevel', null)
          this.selectedRequestType = null
          this.selectedRequirement = null
          this.requestTypeOptions = this.sortOptions(response.data.map(requestType => ({ text: requestType, value: requestType })))
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchRequirements () {
      if (!this.selectedRequestType) {
        this.$emit('setInternalTicketLevel', null)
        this.selectedRequirement = null
        return
      }
      this.$http.get('/api/production/internal_ticket_levels/requirements', {
        params: {
          department: this.selectedDepartment,
          request_type: this.selectedRequestType
        }
      })
        .then(response => {
          this.selectedRequirement = null
          this.requirementOptions = this.sortOptions(response.data.map(requirement => ({ text: requirement.requirement, value: requirement.id })))
        })
        .catch(error => {
          console.log(error)
        })
    },
    setInternalTicketLevel (level_id) {
      this.$emit('setInternalTicketLevel', level_id)
    },
    sortOptions (options) {
      return options.sort((a, b) => a.text.localeCompare(b.text, 'es'))
    }
  }
}
</script>